import {VoucherTag} from './master/voucherTag'
import {VoucherCategory} from './master/voucherCategory'

export class VoucherFilter {
  tags: VoucherTag[] = []
  category?: VoucherCategory
}
